export default "__VITE_ASSET__CSjftZRJ__"